import _regeneratorRuntime from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { CALL_API } from "../api.middleware";
import { GET_DASHBOARD_DATA, GET_DASHBOARD_DATA_SUCCESS, GET_DASHBOARD_DATA_FAILED, GET_TRANSACTION_DATA, GET_TRANSACTION_DATA_SUCCESS, GET_TRANSACTION_DATA_FAILED, GET_AUM_DATA, GET_AUM_DATA_SUCCESS, GET_AUM_DATA_FAILED, GET_FREQUENT_MAIL_BACK_REQUEST, GET_FREQUENT_MAIL_BACK_REQUEST_FAILED, GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS, GET_DASHBOARD_AUM_DATA, GET_DASHBOARD_AUM_DATA_SUCCESS, GET_DASHBOARD_AUM_DATA_FAILED, GET_SIP_SUMMARY_DATA, GET_SIP_SUMMARY_DATA_SUCCESS, GET_SIP_SUMMARY_DATA_FAILED, GET_NFO_SCHEMES, GET_NFO_SCHEMES_SUCCESS, GET_NFO_SCHEMES_FAILED, REMOVE_NFO_SCHEMES } from "../types";
export var getDashboardData = function getDashboardData(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/Dist_Dashboard",
                  params: params,
                  method: "GET",
                  types: [GET_DASHBOARD_DATA, GET_DASHBOARD_DATA_SUCCESS, GET_DASHBOARD_DATA_FAILED],
                  showLoader: true
                }));

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  error: _context.t0
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
export var getTransactionData = function getTransactionData(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/Ktrack_Dist_DetailedTransaction",
                  params: params,
                  method: "GET",
                  types: [GET_TRANSACTION_DATA, GET_TRANSACTION_DATA_SUCCESS, GET_TRANSACTION_DATA_FAILED],
                  showLoader: true
                }));

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  error: _context2.t0
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
export var getAumData = function getAumData(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetDistributorAUM",
                  params: params,
                  method: "GET",
                  types: [GET_AUM_DATA, GET_AUM_DATA_SUCCESS, GET_AUM_DATA_FAILED]
                }));

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", {
                  error: _context3.t0
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};
export var getFrequentMailBackRequest = function getFrequentMailBackRequest() {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/ktrack_frequent_mailback_request",
                  method: "GET",
                  types: [GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS, GET_FREQUENT_MAIL_BACK_REQUEST, GET_FREQUENT_MAIL_BACK_REQUEST_FAILED]
                }));

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", {
                  error: _context4.t0
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 6]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};
export var getDashboardDataAum = function getDashboardDataAum(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(dispatch) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/KtrackDistAumSummary",
                  params: params,
                  method: "GET",
                  types: [GET_DASHBOARD_AUM_DATA, GET_DASHBOARD_AUM_DATA_SUCCESS, GET_DASHBOARD_AUM_DATA_FAILED] // showLoader:

                }));

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", {
                  error: _context5.t0
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 6]]);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
};
export var getSipSummary = function getSipSummary(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(dispatch) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/ktrackGetSipAum",
                  params: params,
                  method: "GET",
                  types: [GET_SIP_SUMMARY_DATA, GET_SIP_SUMMARY_DATA_SUCCESS, GET_SIP_SUMMARY_DATA_FAILED] // showLoader: true,

                }));

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", {
                  error: _context6.t0
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 6]]);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};
export var getNfoSchemes = function getNfoSchemes(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(dispatch) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetNFOSchemes",
                  params: params,
                  method: "GET",
                  types: [GET_NFO_SCHEMES, GET_NFO_SCHEMES_SUCCESS, GET_NFO_SCHEMES_FAILED],
                  showLoader: true
                }));

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", {
                  error: _context7.t0
                });

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 6]]);
      }));

      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};
export var NfoSchemesSubmission = function NfoSchemesSubmission(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(dispatch) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/SendNFOLink",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", {
                  error: _context8.t0
                });

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 6]]);
      }));

      return function (_x8) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};
export var removeNfoSchemes = function removeNfoSchemes() {
  return {
    type: REMOVE_NFO_SCHEMES
  };
};